import { useState } from "react";
import "./css/main.css";
import FieldGroup from "./FieldGroup";
import SmallFieldGroup from "./SmallFieldGroup";
import { fontFamilies } from "./fontFamilies";
import FontSelect from "./FontSelect";

export default function App() {
  const [selectedFont, setSelectedFont] = useState(fontFamilies[0]);

  return (
    <div className="App max-w-6xl mx-auto">
      <div className="m-4 p-4 rounded-md bg-grey-50 w-full">
        <span className="label-1 block"></span>

        <FontSelect
          fontFamilies={fontFamilies}
          onFontSelect={(value) => setSelectedFont(value)}
        />

        <div className="mt-4">
          <p className="help-text">Selected stack:</p>
          <code className="help-text">{selectedFont.fonts}</code>
        </div>
      </div>

      <div className="p-4">
        {selectedFont.type !== "All" && (
          <FieldGroup fonts={selectedFont.fonts} />
        )}
        {selectedFont.type === "All" && (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
            {fontFamilies.map(
              (font) => font.type !== "All" && <SmallFieldGroup font={font} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
